import { RegistrationRequestData } from 'types/dto/registration';
import ApiClient from './apiClient';


export interface EmailVerificationResponse {
    success: boolean;
    message: string;
    email: string;
    tempToken?: string;
    expiresIn?: string;
    uniqueId?: string;
}

export const sendVerificationEmail = async (email: string, phone?: string): Promise<EmailVerificationResponse> => {
  const response = await ApiClient.getInstance().post({
    url: '/register/send-verification-email',
    data: {
      email,
      phone
    }
  });

  return response.data;
};


// An email update request only needs the new address; the backend endpoint
// (/register/update-email) flags the call as email-only (update_email_only = true),
// so any other field is optional and will not be applied to the profile.
export type EmailUpdateRequestData = Pick<RegistrationRequestData, 'email'> &
  Partial<RegistrationRequestData>;

export const updateEmail = async (updatedRequestData: EmailUpdateRequestData): Promise<object> => {
  const response = await ApiClient.getInstance().post({
    url: '/register/update-email',
    data: updatedRequestData
  });

  return response.data;
};

export const verifyEmail = async (token: string): Promise<object> => {
  const response = await ApiClient.getInstance().post({
    url: '/register/verify-email',
    data: {verifyToken: token}
  });

  return response.data;
};
